import React from 'react';
import { Button } from '@framework-controls/core';
import css from './CalendarSelectTime.module.scss';
import classNames from 'classnames';
import { TimeOfDay } from 'src/models';
import { convertTime } from 'src/helpers/TimeDisplayHelper/TimeDisplayHelper';

interface IProps {
    id: string;
    timeRange: TimeOfDay;
    selected: boolean;
    theme: string;
    onClick: (time: TimeOfDay, e: any) => void;
}

const CalendarSelectTimeBtn = (props: IProps) => {
    const btnClassName = classNames(
        css.timeBtn,
        {
            [css.timeBtnChecked]: props.selected,
            [css.timeBtnCS]: props.theme === 'colorSensitive',
            [css.timeBtnCA]: props.theme === 'cadillac',
            [css.timeBtnHonda]: props.theme === 'honda',
            [css.timeBtnHyundai]: props.theme === 'hyundai',
            [css.timeBtnBuick]: props.theme === 'buick',
            [css.timeBtnBMW]: props.theme === 'bmw',
            [css.timeBtnFord]: props.theme === 'ford',
            [css.timeBtnIN]: props.theme === 'infiniti',
            [css.timeBtnMazda]: props.theme === 'mazda',
            [css.timeBtnGenesis]: props.theme === 'genesis',
            [css.timeBtnAcura]: props.theme === 'acura',
        },
    );

    const startTime = convertTime(props.timeRange.startTime);
    const endTime = convertTime(props.timeRange.endTime);
    const range = startTime + ' - ' + endTime;

    return (
        <div className={btnClassName}>
            <Button
                id={props.id + 'Btn'}
                onClick={(e: any) => props.onClick(props.timeRange, e)}
                variant='calBtn'
                disableRipple
                type={'custom'}>
                <div className={css.timeBtnContents}>
                    {props.id}
                </div>
                {
                    parseInt(props.timeRange.startTime) > parseInt(props.timeRange.endTime) ?
                        null : <div className={css.timeBtnContents}>{range}</div>
                }
            </Button>
        </div>
    );
};

export default CalendarSelectTimeBtn;